export const buttonPositions = {
    '1': [
        { top: '0px', left: '125px' }
    ],
    '2': [
        { top: '-40px', left: '125px' },
        { top: '40px', left: '125px' }
    ],
    '3': [
        { top: '-100px', left: '100px' },
        { top: '0px', left: '125px' },
        { top: '100px', left: '100px' }
    ],
    '4': [
        { top: '-120px', left: '100px' },
        { top: '-40px', left: '125px' },
        { top: '40px', left: '125px' },
        { top: '120px', left: '100px' }
    ],
    '5': [
        { top: '-160px', left: '65px' },
        { top: '-80px', left: '100px' },
        { top: '0px', left: '125px' },
        { top: '80px', left: '100px' },
        { top: '160px', left: '65px' }
    ],
    '6': [
        { top: '-200px', left: '50px' },
        { top: '-120px', left: '100px' },
        { top: '-40px', left: '125px' },
        { top: '40px', left: '125px' },
        { top: '120px', left: '100px' },
        { top: '200px', left: '50px' }
    ],
    '7': [
        { top: '-200px', left: '50px' },
        { top: '-140px', left: '80px' },
        { top: '-75px', left: '100px' },
        { top: '0px', left: '120px' },
        { top: '75px', left: '100px' },
        { top: '140px', left: '80px' },
        { top: '200px', left: '50px' }
    ],
    '8': [
        { top: '-200px', left: '50px' },
        { top: '-140px', left: '80px' },
        { top: '-75px', left: '100px' },
        { top: '-10px', left: '120px' },
        { top: '55px', left: '120px' },
        { top: '120px', left: '100px' },
        { top: '185px', left: '80px' },
        { top: '245px', left: '50px' }
    ],
    '9': [
        { top: '-220px', left: '50px' },
        { top: '-165px', left: '80px' },
        { top: '-110px', left: '100px' },
        { top: '-55px', left: '120px' },
        { top: '0px', left: '130px' },
        { top: '55px', left: '120px' },
        { top: '110px', left: '100px' },
        { top: '165px', left: '80px' },
        { top: '220px', left: '50px' }
    ],
    '10': [
        { top: '-240px', left: '50px' },
        { top: '-180px', left: '80px' },
        { top: '-120px', left: '100px' },
        { top: '-60px', left: '120px' },
        { top: '0px', left: '130px' },
        { top: '60px', left: '120px' },
        { top: '120px', left: '100px' },
        { top: '180px', left: '80px' },
        { top: '240px', left: '50px' },
        { top: '300px', left: '30px' }
    ],
    '11': [
        { top: '-260px', left: '50px' },
        { top: '-200px', left: '80px' },
        { top: '-140px', left: '100px' },
        { top: '-80px', left: '120px' },
        { top: '-20px', left: '130px' },
        { top: '40px', left: '130px' },
        { top: '100px', left: '120px' },
        { top: '160px', left: '100px' },
        { top: '220px', left: '80px' },
        { top: '280px', left: '50px' },
        { top: '340px', left: '30px' }
    ],
    '12': [
        { top: '-280px', left: '50px' },
        { top: '-220px', left: '80px' },
        { top: '-160px', left: '100px' },
        { top: '-100px', left: '120px' },
        { top: '-40px', left: '130px' },
        { top: '20px', left: '130px' },
        { top: '80px', left: '120px' },
        { top: '140px', left: '100px' },
        { top: '200px', left: '80px' },
        { top: '260px', left: '50px' },
        { top: '320px', left: '30px' },
        { top: '380px', left: '10px' }
    ],
    '13': [
        { top: '-300px', left: '50px' },
        { top: '-240px', left: '80px' },
        { top: '-180px', left: '100px' },
        { top: '-120px', left: '120px' },
        { top: '-60px', left: '130px' },
        { top: '0px', left: '130px' },
        { top: '60px', left: '130px' },
        { top: '120px', left: '120px' },
        { top: '180px', left: '100px' },
        { top: '240px', left: '80px' },
        { top: '300px', left: '50px' },
        { top: '360px', left: '30px' },
        { top: '420px', left: '10px' }
    ],
    '14': [
        { top: '-320px', left: '50px' },
        { top: '-260px', left: '80px' },
        { top: '-200px', left: '100px' },
        { top: '-140px', left: '120px' },
        { top: '-80px', left: '130px' },
        { top: '-20px', left: '130px' },
        { top: '40px', left: '130px' },
        { top: '100px', left: '120px' },
        { top: '160px', left: '100px' },
        { top: '220px', left: '80px' },
        { top: '280px', left: '50px' },
        { top: '340px', left: '30px' },
        { top: '400px', left: '10px' },
        { top: '460px', left: '-10px' }
    ],
    '15': [
        { top: '-340px', left: '50px' },
        { top: '-280px', left: '80px' },
        { top: '-220px', left: '100px' },
        { top: '-160px', left: '120px' },
        { top: '-100px', left: '130px' },
        { top: '-40px', left: '130px' },
        { top: '20px', left: '130px' },
        { top: '80px', left: '120px' },
        { top: '140px', left: '100px' },
        { top: '200px', left: '80px' },
        { top: '260px', left: '50px' },
        { top: '320px', left: '30px' },
        { top: '380px', left: '10px' },
        { top: '440px', left: '-10px' },
        { top: '500px', left: '-30px' }
    ],
    '16': [
        { top: '-360px', left: '50px' },
        { top: '-300px', left: '80px' },
        { top: '-240px', left: '100px' },
        { top: '-180px', left: '120px' },
        { top: '-120px', left: '130px' },
        { top: '-60px', left: '130px' },
        { top: '0px', left: '130px' },
        { top: '60px', left: '130px' },
        { top: '120px', left: '120px' },
        { top: '180px', left: '100px' },
        { top: '240px', left: '80px' },
        { top: '300px', left: '50px' },
        { top: '360px', left: '30px' },
        { top: '420px', left: '10px' },
        { top: '480px', left: '-10px' },
        { top: '540px', left: '-30px' }
    ],
    '17': [
        { top: '-380px', left: '50px' },
        { top: '-320px', left: '80px' },
        { top: '-260px', left: '100px' },
        { top: '-200px', left: '120px' },
        { top: '-140px', left: '130px' },
        { top: '-80px', left: '130px' },
        { top: '-20px', left: '130px' },
        { top: '40px', left: '130px' },
        { top: '100px', left: '120px' },
        { top: '160px', left: '100px' },
        { top: '220px', left: '80px' },
        { top: '280px', left: '50px' },
        { top: '340px', left: '30px' },
        { top: '400px', left: '10px' },
        { top: '460px', left: '-10px' },
        { top: '520px', left: '-30px' },
        { top: '580px', left: '-50px' }
    ],
    '18': [
        { top: '-400px', left: '50px' },
        { top: '-340px', left: '80px' },
        { top: '-280px', left: '100px' },
        { top: '-220px', left: '120px' },
        { top: '-160px', left: '130px' },
        { top: '-100px', left: '130px' },
        { top: '-40px', left: '130px' },
        { top: '20px', left: '130px' },
        { top: '80px', left: '130px' },
        { top: '140px', left: '120px' },
        { top: '200px', left: '100px' },
        { top: '260px', left: '80px' },
        { top: '320px', left: '50px' },
        { top: '380px', left: '30px' },
        { top: '440px', left: '10px' },
        { top: '500px', left: '-10px' },
        { top: '560px', left: '-30px' },
        { top: '620px', left: '-50px' }
    ],
    '19': [
        { top: '-420px', left: '50px' },
        { top: '-360px', left: '80px' },
        { top: '-300px', left: '100px' },
        { top: '-240px', left: '120px' },
        { top: '-180px', left: '130px' },
        { top: '-120px', left: '130px' },
        { top: '-60px', left: '130px' },
        { top: '0px', left: '130px' },
        { top: '60px', left: '130px' },
        { top: '120px', left: '120px' },
        { top: '180px', left: '100px' },
        { top: '240px', left: '80px' },
        { top: '300px', left: '50px' },
        { top: '360px', left: '30px' },
        { top: '420px', left: '10px' },
        { top: '480px', left: '-10px' },
        { top: '540px', left: '-30px' },
        { top: '600px', left: '-50px' },
        { top: '660px', left: '-70px' }
    ],
    '20': [
        { top: '-440px', left: '50px' },
        { top: '-380px', left: '80px' },
        { top: '-320px', left: '100px' },
        { top: '-260px', left: '120px' },
        { top: '-200px', left: '130px' },
        { top: '-140px', left: '130px' },
        { top: '-80px', left: '130px' },
        { top: '-20px', left: '130px' },
        { top: '40px', left: '130px' },
        { top: '100px', left: '130px' },
        { top: '160px', left: '120px' },
        { top: '220px', left: '100px' },
        { top: '280px', left: '80px' },
        { top: '340px', left: '50px' },
        { top: '400px', left: '30px' },
        { top: '460px', left: '10px' },
        { top: '520px', left: '-10px' },
        { top: '580px', left: '-30px' },
        { top: '640px', left: '-50px' },
        { top: '700px', left: '-70px' }
    ]
};